import { useState } from 'react';
import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';

import Button from '@/views/components/Buttons/Button';
import AddProductFullModal from '@/views/screens/Claims/common/AddProductFull/AddProductFullModal';

import PreClaimsItemCard from './PreClaimsItemCard';

const PreClaimsItems = ({ itemList, setItemList, onFieldsChange }) => {
  const [addProductModal, setAddProductModal] = useState(false);
  const [addProductModalIndex, setAddProductModalIndex] = useState(false);
  const setEditMode = (index, val) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[index].editMode = val;
    setItemList(itemListLocal);
  };

  const handleCancel = (index, isNew) => {
    const itemListLocal = cloneDeep(itemList);
    if (isNew) {
      itemListLocal.splice(index, 1);
    } else {
      itemListLocal[index] = {
        ...itemListLocal[index],
        editMode: false,
      };
    }
    setItemList(itemListLocal);
  };

  const handleSubmit = (data, index) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[index] = { ...data, editMode: false, isNew: false };
    setItemList(itemListLocal);
  };

  const handleDelete = (index) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal.splice(index, 1);
    setItemList(itemListLocal);
  };

  const handleAddNew = () => {
    let itemListLocal = cloneDeep(itemList);
    let nextSequence = maxBy(itemListLocal, ({ itemSeq }) => Number(itemSeq));
    nextSequence = nextSequence ? nextSequence.itemSeq : 0;
    itemListLocal = [
      {
        claimKey: 0,
        dirtyFlag: 'i',
        dispositionMethod: '',
        editMode: true,
        fullRelFlag: '',
        isNew: true,
        itemCode: '',
        itemDesc: '',
        itemQuantity: undefined,
        itemSeq: nextSequence + 1,
        itemUnitMeasure: '',
        measure: '',
        smAmount: undefined,
        smFlag: '',
        smType: '',
        value: undefined,
      },
      ...itemListLocal,
    ];
    setItemList(itemListLocal);
  };

  const handleNewProductModal = (index) => {
    setAddProductModalIndex(index);
    setAddProductModal(true);
  };

  const onSelectAddressBook = (data) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[addProductModalIndex] = {
      ...itemListLocal[addProductModalIndex],
      editMode: true,
      fullRelFlag: data.fullRelFlag,
      isNew: true,
      itemCode: data.productCode,
      itemDesc: data.productDesc,
      itemUnitMeasure: data.productUnitMeasure,
      itemUnitWeight: data.productWeight,
    };
    setItemList(itemListLocal);
    handleAddProductModalClose();
  };

  const handleAddProductModalClose = () => {
    setAddProductModal(false);
    setAddProductModalIndex(false);
  };

  return (
    <div>
      <Row className="align-items-center" justify="space-between">
        <Col />
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew}>Add New Item</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div>
          {itemList.map((row, index) => (
            <PreClaimsItemCard
              itemDetails={row}
              key={row.itemSeq}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
              handleNewProductModal={handleNewProductModal}
              onFieldsChange={onFieldsChange}
            />
          ))}
        </div>
      </div>
      <AddProductFullModal
        addressBookModal={addProductModal && addProductModalIndex !== false}
        onSelectAddressBook={onSelectAddressBook}
        handleAddressBookModalClose={handleAddProductModalClose}
      />
    </div>
  );
};

export default PreClaimsItems;
